<template lang="pug">
  router-link(
    v-if="!hasChildren",
    :to="path",
  ).menu-item
    NavigationDrawerMenuIcon(
      v-if="showIcon"
      :name="slug"
    )
    .menu-item__name
      span {{name}}
      slot(name="name-info")
      span.is-notification(v-show="isNotification")
  .list-menu(v-else)
    router-link(
      :to="path",
      :class="{'has-children': isActiveChildren, 'farm-owners': isFarmOwnersPage}"
    ).menu-item
      NavigationDrawerMenuIcon(
        v-if="showIcon"
        :name="slug"
      )
      .menu-item__name {{name}}
    .list-menu__submenu(
      v-for="subMenuItem in children",
      :key="subMenuItem.path",
    )
      router-link(
        v-if="subMenuItem.path.startsWith('/')"
        :to="subMenuItem.path",
      ).menu-item
        .menu-item__name {{subMenuItem.name}}
      a(
        v-else
        :href="subMenuItem.path"
        :target="checkHost(subMenuItem.path) ? '_self' : '_blank'"
      ).menu-item
        .menu-item__name {{subMenuItem.name}}
</template>

<script>
import CONFIG from 'Config';
import NavigationDrawerMenuIcon from './NavigationDrawerMenuIcon';

export default {
  name: 'NavigationDrawerMenuItem',
  components: {
    NavigationDrawerMenuIcon,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    path: {
      type: String,
    },
    children: {
      default: () => ([]),
      type: Array,
    },
    slug: String,
    isNotification: Boolean,
    showIcon: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    hasChildren() {
      return this.children.length;
    },
    isActiveChildren() {
      const { path } = this.$route;
      return this.children.some(val => path.startsWith(val.path));
    },
    isFarmOwnersPage() {
      const { name } = this.$route;
      return Boolean(name === 'farm-owners');
    },
  },
  methods: {
    checkHost(path) {
      return path.startsWith(CONFIG.urls.frontend);
    },
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.menu-item
  font-size: 12px
  line-height: 26px
  display: flex
  flex-direction: row
  align-items: center
  position: relative
  padding-top: 7px
  padding-bottom: 7px
  transition: none
  &:after
    content: ''
    position: absolute
    right: 0
    bottom: 0
    width: 208px
    height: 2px
    border-bottom: 1px solid $support_lightgray
  ::v-deep .svg-icon
    opacity: 0.3
    position: relative
    z-index: 2
    &.active-icon
      overflow: hidden
      opacity: 0
      width: 0
      height: 0
    &.company
      filter: grayscale(100%)
  &__name
    width: 100%
    position: relative
    z-index: 2
    padding-top: 7px
    padding-bottom: 8px
    padding-right: 20px
    display: flex
    flex-direction: row
    align-items: center
    justify-content: space-between
    .is-notification
      width: 6px
      height: 6px
      border-radius: 100%
      background-color: $support_red
  &.router-link-exact-active,
  &.router-link-active
    .menu-item__name
      &:before
        content: ''
        position: absolute
        width: 200%
        height: 100%
        top: 0
        left: -100%
        background-color: rgba($support_yellow, 0.15)
        z-index: 1
  &.router-link-active,
  &.router-link-exact-active,
  &.has-children
    ::v-deep .svg-icon
      opacity: 1
      &.not-active
        opacity: 0
        overflow: hidden
        width: 0
        height: 0
      &.active-icon
        opacity: 1
        overflow: visible
        height: sizeInRem(10)
        width: sizeInRem(10)
      &.company
        filter: grayscale(0%)
  &.farm-owners
    ::v-deep .active-icon
      opacity: 0 !important
      overflow: hidden !important
      width: 0 !important
      height: 0 !important
    ::v-deep .not-active
      opacity: 0.3 !important
      overflow: visible !important
      height: sizeInRem(10) !important
      width: sizeInRem(10) !important
    .menu-item__name
      &:before
        display: none !important
  &.router-link-active
    &.has-children
      .menu-item__name
        &:before
          display: none
.list-menu
  margin-top: 8px
  position: relative
  &:after
    content: ''
    position: absolute
    right: 0
    bottom: 0
    width: 208px
    height: 2px
    border-bottom: 1px solid $support_lightgray
  &:last-child
    margin-bottom: 20px
    &:after
      display: none
    .list-menu__submenu
      &:last-child
        .menu-item
          margin-bottom: 0
  .menu-item
    padding: 0
    &:after
      display: none
    &__name
      border-bottom: none
      padding-top: 7px
      padding-bottom: 8px
  &__submenu
    padding-left: 29px
    .menu-item
      padding: 0
      font-family: $font-medium
      font-weight: 500
    &:last-child
      .menu-item
        margin-bottom: 7px
</style>
